import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { setCookie } from "./utils";

export default function Login({ loggedIn }) {
  const [id, setId] = useState("");
  const [authenticating, setAuthenticating] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const navigate = useNavigate();

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setAuthenticating(true);
    try {
      const response = await axios.post("/OneLogin/Login.php", { Id: id });

      if (response.data.status === "Valid") {
        setCookie("ITS_ID", id, 4);
        setCookie("SESSION_TOKEN", response.data.token, 4);
        loggedIn(true);
        navigate("/ActiveEvents");

        setSnackbarMessage("Login successful");
        setSnackbarSeverity("success");
      } else if (response.data.status === "InvalidITS") {
        setSnackbarMessage("Invalid ITS number");
        setSnackbarSeverity("error");
      } else if (response.data.status === "AlreadyLoggedIn") {
        const device = response.data.device || "another device";
        setSnackbarMessage(
          `User is already logged in on ${device}. Please logout there first.`
        );
        setSnackbarSeverity("error");
      } else {
        setSnackbarMessage("Unexpected response. Try again later.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Login error:", error);
      setSnackbarMessage("An error occurred during login. Please try again.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
      setAuthenticating(false);
    }
  };

  return (
    <>
      <section className="login-main-wrapper">
        <div className="container-fluid pl-0 pr-0">
          <div className="row no-gutters">
            <div className="col-md-12 p-5 py-5 bg-white full-height">
              <div className="login-main-left">
                <div className="text-center mb-5 login-main-left-header pt-4">
                  <img
                    src="/Assets/img/Logo_Bhopal_Jamaat.png"
                    className="img-fluid"
                    alt="LOGO"
                    style={{ marginTop: "-50px", height: "50%", width: "50%" }}
                  />
                  <h5 className="mt-3 mb-3">
                    Welcome to Haidery Masjid - Bhopal
                  </h5>
                  <p>A platform for live majlis streaming and live events.</p>
                </div>

                <form onSubmit={handleLogin}>
                  <div className="form-group">
                    <label>ITS ID</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ITS ID"
                      required
                      name="ITS"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                    />
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-outline-info btn-block btn-lg"
                      disabled={!id || authenticating}
                    >
                      {authenticating
                        ? "Authenticating..."
                        : id
                        ? "Login"
                        : "Please Enter ITS ID"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={8000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
